// Movatic WMS — Frontend | CesarFilho 932048016
// Arquivo: src/pages/ScanTest.tsx
// -----------------------------------------------------------------------------
// Página simples para validar a leitura no desktop (leitor HID) e no Zebra
// (DataWedge Keystroke com sufixo Enter). Mantém histórico e mostra o último scan.
// -----------------------------------------------------------------------------

import React, { useState } from 'react';
import ScanInput from '@/components/ScanInput';

export default function ScanTest() {
    const [last, setLast] = useState<string>('');
    const [history, setHistory] = useState<string[]>([]);

    const onScan = (code: string) => {
        setLast(code);
        setHistory((h) => [code, ...h].slice(0, 20));
        // Exemplo de chamada de API (comente/descomente quando quiser usar):
        // fetch('/api/ping/').then(r => r.json()).then(console.log).catch(console.error);
    };

    return (
        <div className="p-4 max-w-2xl mx-auto">
            <h1 className="text-xl font-semibold mb-2">Teste de Leitura (Scan)</h1>

            <div className="mb-4">
                <label className="block mb-2 text-sm opacity-80">
                    Foco neste campo e dispare o scan (Enter como sufixo)
                </label>
                <ScanInput prefix="^MVT^" onScan={onScan} />
            </div>

            <div className="mb-4">
                <div className="text-sm opacity-80 mb-1">Último scan</div>
                <div className="p-3 rounded-lg border bg-black/20">{last || '—'}</div>
            </div>

            <div>
                <div className="text-sm opacity-80 mb-1">Histórico (20)</div>
                <ul className="space-y-1">
                    {history.map((c, i) => (
                        <li key={i} className="px-3 py-2 rounded border bg-black/10">{c}</li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
